import { apiRequest } from '../core';
import type { MeCapabilities } from './capabilities.types';

const ME_CAPABILITIES_ENDPOINT = '/v1/me/capabilities';

/** What the signed-in caller may do. Advisory — every write re-checks independently. */
export function getMeCapabilities() {
  return apiRequest<MeCapabilities>('get', ME_CAPABILITIES_ENDPOINT);
}
